/**
 * Detects the benign browser warning that fires when JavaScript calls
 * `event.preventDefault()` on a touch event whose `cancelable` property
 * is already `false` — typically because the browser has started passive
 * scrolling and the gesture can no longer be cancelled.
 *
 * This commonly originates from `signature_pad` (via `react-signature-canvas`)
 * which unconditionally calls `preventDefault()` on `touchmove`. The CSS fix
 * `touch-action: none` reduces the frequency, but edge cases (e.g. momentum
 * scrolling into the canvas area) can still trigger it.
 *
 * The warning is harmless: the browser simply ignores the `preventDefault()`
 * call and continues scrolling. It does not indicate a bug or data loss.
 */
export function isIgnoredEventCancelNoise(
  message: string | undefined,
): boolean {
  if (!message) {
    return false;
  }
  const normalized = message.toLowerCase();
  return (
    normalized.includes("ignored attempt to cancel") &&
    normalized.includes("cancelable=false")
  );
}
